import NS from 'src/ns';
import detect from 'src/utility/detect';
import smoothScroll from 'src/utility/smoothScroll';
import expanded from 'src/utility/expanded';
import flatHeight from 'src/utility/flatHeight';
import MissionStatement from 'src/block/missionStatement';
import Drawer from 'src/block/drawer';
import AboutUs from 'src/block/aboutUs';
import Project from 'src/block/project';
import IndexPage from 'src/block/indexPage';

function init() {
  console.log(detect);

  detect.addClass();
  MissionStatement.createAll();
  Drawer.create();
  AboutUs.createAll();
  Project.createAll();
  smoothScroll.observe(null, { easing: 'linear', duration: 800 });
}

$(function() {
  init();
});



// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/main.js